/**
 * OVERRIDE LanguageSelector.tsx
 * REASON: Show only two letters of the native language name.
 * SemanticUI-free located at the components folder.
 * To override it, override the @kitconcept/volto-light-theme one instead of
 * this one.
 */
import LanguageSelector from '../../../../../components/LanguageSelector/LanguageSelector';

export default LanguageSelector;
